import { viewActionCreator } from '../../events/view/view';

const { set } = viewActionCreator;

const setContext = context => dispatch => dispatch(set({ context }));

export default setContext;
